window.GrovaSections.register('campaign-digestion-offer', '.section-campaign-digestion-pricing-offer .gprice-section', (section, scope) => {
  var purchasePending = false;

  var shippingEls = section.querySelectorAll('[data-ships-countdown]');
  var cartClearUrl = section.getAttribute('data-cart-clear-url');
  var cartAddUrl = section.getAttribute('data-cart-add-url');
  var checkoutUrl = section.getAttribute('data-checkout-url');
  var shippingStartedAt = Date.now();
  var shippingDuration = ((1 * 60 * 60) + (56 * 60) + 43) * 1000;

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function updateShippingCountdown() {
    var remaining = Math.max(0, shippingDuration - (Date.now() - shippingStartedAt));
    var hours = Math.floor(remaining / (1000 * 60 * 60));
    var minutes = Math.floor((remaining / (1000 * 60)) % 60);
    var seconds = Math.floor((remaining / 1000) % 60);
    var label = hours + 'hr ' + pad(minutes) + 'mins ' + pad(seconds) + ' sec';

    shippingEls.forEach(function(element) {
      element.textContent = label;
    });
  }

  function initStickySale() {
    var stickySale = document.querySelector('[data-gprice-sticky-sale]');
    var heroSection = document.querySelector('.gwrh');
    if (!stickySale) return;

    if (!('IntersectionObserver' in window)) {
      stickySale.classList.remove('is-hidden');
      return;
    }

    var heroVisible = Boolean(heroSection);
    var purchaseVisible = false;

    function updateStickyVisibility() {
      stickySale.classList.toggle('is-hidden', heroVisible || purchaseVisible);
    }

    var purchaseObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        purchaseVisible = entry.isIntersecting;
        updateStickyVisibility();
      });
    }, { threshold: 0.04 });

    purchaseObserver.observe(section);
    scope.cleanup(function() { purchaseObserver.disconnect(); });

    if (heroSection) {
      var heroObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          heroVisible = entry.isIntersecting;
          updateStickyVisibility();
        });
      }, { threshold: 0.04 });

      heroObserver.observe(heroSection);
      scope.cleanup(function() { heroObserver.disconnect(); });
    } else {
      heroVisible = false;
      updateStickyVisibility();
    }
  }

  function resetPurchaseControls() {
    purchasePending = false;
    var config = window.GrovaOffers.read(section);
    section.querySelectorAll('.gprice-button, .gprice-onetime').forEach(function(control) {
      var originalContent = control.getAttribute('data-original-content');
      if (originalContent !== null) control.innerHTML = originalContent;
      control.removeAttribute('aria-busy');
      var card = control.closest('.gprice-card');
      var option = config.primary.find(function(candidate) { return candidate.key === (card.id === 'grova-offer' ? '3' : '1'); });
      control.disabled = !window.GrovaOffers.canBuy(config, option, control.classList.contains('gprice-button'));
    });
  }

  function launchConfetti(control) {
    if (!control || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var colors = ['#003d14', '#008532', '#4f8a46', '#edc75c', '#f7f5ee', '#ffffff'];
    var bounds = control.getBoundingClientRect();
    var originX = bounds.left + (bounds.width / 2);
    var originY = bounds.top + (bounds.height / 2);
    var confetti = document.createElement('div');
    confetti.className = 'gprice-confetti';
    confetti.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 42; index += 1) {
      var piece = document.createElement('i');
      var horizontalTravel = (Math.random() - 0.5) * Math.min(window.innerWidth * 0.72, 620);
      var verticalTravel = 180 + (Math.random() * 320);
      piece.className = 'gprice-confetti__piece';
      piece.style.left = originX + 'px';
      piece.style.top = originY + 'px';
      piece.style.setProperty('--confetti-color', colors[index % colors.length]);
      piece.style.setProperty('--confetti-x', horizontalTravel + 'px');
      piece.style.setProperty('--confetti-y', verticalTravel + 'px');
      piece.style.setProperty('--confetti-lift', (-70 - (Math.random() * 150)) + 'px');
      piece.style.setProperty('--confetti-rotate', ((Math.random() - 0.5) * 900) + 'deg');
      piece.style.setProperty('--confetti-delay', (Math.random() * 0.12) + 's');
      confetti.appendChild(piece);
    }

    document.body.appendChild(confetti);
    window.setTimeout(function() {
      confetti.remove();
    }, 1500);
  }

  function initPurchaseCards() {
    var cards = section.querySelectorAll('.gprice-card');

    scope.on(section, 'click', function(event) {
      var quantityButton = event.target.closest('[data-qty-change]');
      if (!quantityButton || !section.contains(quantityButton)) return;

      var quantityWrap = quantityButton.closest('.gprice-qty');
      var quantityValue = quantityWrap ? quantityWrap.querySelector('span') : null;
      if (!quantityValue) return;

      var currentQuantity = Math.max(1, parseInt(quantityValue.textContent, 10) || 1);
      var change = parseInt(quantityButton.getAttribute('data-qty-change'), 10) || 0;
      quantityValue.textContent = Math.max(1, currentQuantity + change);
    });

    cards.forEach(function(card) {
      var quantityWrap = card.querySelector('.gprice-qty');
      var quantityValue = quantityWrap ? quantityWrap.querySelector('span') : null;
      var subscribeButton = card.querySelector('.gprice-button');
      var oneTimeButton = card.querySelector('.gprice-onetime');

      [subscribeButton, oneTimeButton].forEach(function(control) {
        if (control && !control.hasAttribute('data-original-content')) {
          control.setAttribute('data-original-content', control.innerHTML);
        }
      });

      function getQuantity() {
        return Math.max(1, parseInt(quantityValue ? quantityValue.textContent : '1', 10) || 1);
      }

      function addPurchase(control, includeSellingPlan) {
        if (!control || control.getAttribute('aria-busy') === 'true') return;

        if (purchasePending) return;
        var config = window.GrovaOffers.read(section);
        var option = config.primary.find(function(candidate) {
          return candidate.key === (card.id === 'grova-offer' ? '3' : '1');
        });
        var items;
        try {
          items = window.GrovaOffers.items(config, option, includeSellingPlan, getQuantity());
        } catch (error) {
          window.alert(error.message);
          return;
        }
        purchasePending = true;

        var originalContent = control.getAttribute('data-original-content') || control.innerHTML;
        control.setAttribute('aria-busy', 'true');
        if ('disabled' in control) control.disabled = true;
        control.textContent = 'ADDING…';

        fetch(cartClearUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({})
        })
          .then(function(response) {
            if (response.ok) return response.json();
            throw new Error('Unable to clear the cart');
          })
          .then(function() {
            return fetch(cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: items })
            });
          })
          .then(function(response) {
            if (response.ok) return response.json();
            return response.json().then(function(data) {
              throw new Error(data.description || 'Unable to add this item');
            });
          })
          .then(function() {
            window.location.assign(checkoutUrl);
          })
          .catch(function(error) {
            purchasePending = false;
            console.error(error);
            control.innerHTML = originalContent;
            control.removeAttribute('aria-busy');
            if ('disabled' in control) control.disabled = false;
            window.alert('Sorry, this option could not be added. Please try again.');
          });
      }

      if (subscribeButton) {
        scope.on(subscribeButton, 'click', function() {
          launchConfetti(subscribeButton);
          addPurchase(subscribeButton, true);
        });
      }

      if (oneTimeButton) {
        scope.on(oneTimeButton, 'click', function(event) {
          event.preventDefault();
          addPurchase(oneTimeButton, false);
        });
      }
    });
  }

  function initCarousels() {
    var carousels = section.querySelectorAll('[data-grova-carousel]');

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('.gprice-carousel-track');
      var slides = carousel.querySelectorAll('.gprice-slide');
      var prev = carousel.querySelector('.gprice-carousel-arrow.prev');
      var next = carousel.querySelector('.gprice-carousel-arrow.next');
      var dots = carousel.querySelectorAll('.gprice-dot');
      var viewport = carousel.querySelector('.gprice-carousel');
      var index = 0;

      var startX = 0;
      var currentX = 0;
      var isDragging = false;
      var dragThreshold = 50;

      function goTo(newIndex) {
        if (!track || !slides.length) return;

        index = newIndex;

        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        track.style.transition = 'transform 0.35s ease';
        track.style.transform = 'translateX(-' + (index * 100) + '%)';

        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function getClientX(event) {
        if (event.touches && event.touches.length) return event.touches[0].clientX;
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
        return event.clientX;
      }

      function dragStart(event) {
        isDragging = true;
        startX = getClientX(event);
        currentX = startX;
        track.style.transition = 'none';
      }

      function dragMove(event) {
        if (!isDragging) return;
        currentX = getClientX(event);
      }

      function dragEnd() {
        if (!isDragging) return;

        var deltaX = currentX - startX;
        isDragging = false;

        if (Math.abs(deltaX) > dragThreshold) {
          if (deltaX < 0) {
            goTo(index + 1);
          } else {
            goTo(index - 1);
          }
        } else {
          goTo(index);
        }
      }

      if (prev) {
        scope.on(prev, 'click', function() {
          goTo(index - 1);
        });
      }

      if (next) {
        scope.on(next, 'click', function() {
          goTo(index + 1);
        });
      }

      dots.forEach(function(dot, dotIndex) {
        scope.on(dot, 'click', function() {
          goTo(dotIndex);
        });
      });

      if (viewport) {
        scope.on(viewport, 'touchstart', dragStart, { passive: true });
        scope.on(viewport, 'touchmove', dragMove, { passive: true });
        scope.on(viewport, 'touchend', dragEnd);
        scope.on(viewport, 'mousedown', dragStart);
        scope.on(viewport, 'mousemove', dragMove);
        scope.on(viewport, 'mouseup', dragEnd);
        scope.on(viewport, 'mouseleave', dragEnd);
      }

      goTo(0);
    });
  }

  updateShippingCountdown();
  scope.interval(updateShippingCountdown, 1000);
  initPurchaseCards();
  initCarousels();
  resetPurchaseControls();
  initStickySale();

  scope.on(window, 'pagehide', resetPurchaseControls);
  scope.on(window, 'pageshow', resetPurchaseControls);
});
